import { observer } from "mobx-react-lite";
import styles from "./OtherUsers.module.css";
import styles_alt from "../UserPanel.module.css";
import { userStore } from "@/stores/UserStore";
//import { Permissions } from "../Permissions";
import { OtherUser } from "./OtherUser";
import { SaveButton } from "@/components/button/SaveEditCancel/SaveButton";
import { userAnotherPanelState } from "@/stores/ComponentsState/UserAnotherPanelState";
import PlusIcon from "@/assets/icons/common/plus.svg?react";
import { permissionsStore } from "@/stores/PermissionsStore";
import React from "react";
import { Popup } from "./Popup";
import { User } from "@/types/User.interface";

export const OtherUsers = observer(() => {
  const permissions = permissionsStore.getPermissionsByRoleId(userStore.role!);
  const { users } = permissions!.typePermissions;

  return (
    <React.Fragment>
      <div className={styles_alt.otherUsersHead}>
        {userStore.otherUsers.length > 0 && <h3>Другие учетные записи</h3>}
        {users.add ? (
          <SaveButton onClick={() => userAnotherPanelState.setCurrentUser(null, "add")} icon={<PlusIcon />}>
            Добавить новую учетную запись
          </SaveButton>
        ) : null}
      </div>
      {userStore.otherUsers.length !== 0 && (
        <div className={styles.otherUsers}>
          {userStore.otherUsers.map((user) => (
            <OtherUser key={`other-user-${user.id}`} user={user} />
          ))}
        </div>
      )}
      <Popup user={userAnotherPanelState.CURRENT_USER as User} />
    </React.Fragment>
  );
});
